import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8d752d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "futures-appropriateness-retake-modal__message" }

import { type PropType } from 'vue';

import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


const __default__ = {
  name: 'FuturesAppropriatenessRetakeModal',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  canDismiss: { type: Boolean, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  emits: ["back", "dismiss", "retake"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "futures-appropriateness-retake-modal",
    title: _ctx.$t('ui.futuresAppropriatenessRetakeModal.title'),
    variant: __props.variant,
    "can-close": "",
    wide: ""
  }, {
    content: _withCtx(() => [
      _createVNode(_component_ot_icon, {
        name: "info-circle-bulk",
        class: "futures-appropriateness-retake-modal__icon"
      }),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('ui.futuresAppropriatenessRetakeModal.message')), 1)
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        variant: "primary",
        text: _ctx.$t('ui.futuresAppropriatenessRetakeModal.action.retakeTest'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retake')))
      }, null, 8, ["text"]),
      (__props.canDismiss)
        ? (_openBlock(), _createBlock(_component_x_button, {
            key: 0,
            variant: "outline",
            text: _ctx.$t('ui.futuresAppropriatenessRetakeModal.action.dismiss'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('dismiss')))
          }, null, 8, ["text"]))
        : (_openBlock(), _createBlock(_component_x_button, {
            key: 1,
            variant: "outline",
            text: _ctx.$t('fundamentals.goBack'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('back')))
          }, null, 8, ["text"]))
    ]),
    _: 1
  }, 8, ["title", "variant"]))
}
}

})